import AuthHelper from "../../utils/AuthHelper";
import { hashHistory } from 'react-router';

function checkAuth() {
  if (!AuthHelper.isAuthenticated) {
      hashHistory.push("/login");
  }
}

module.exports = {
  path: 'app',
  onEnter: checkAuth,
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        // require('./routes/instagram'),
        require('./routes/products'),
        require('./routes/banners'),
        require('./routes/menu'),
        require('./routes/slugs'),
        require('./routes/pages'),
        require('./routes/dashboard'),
        require('./reports'),
        require('./users'),
        require('./routes/links'),
        require('./routes/shipment-types'),
        require('./configuration'),
        require('./routes/eventLogs'),
        require('./routes/recommendation'),
        require('./routes/specialOffers'),
        require('./routes/listingCart'),
        require('./routes/promoEngine'),
        require('./routes/staticUrl'),
      ]);
    }, 'app');
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/MainApp').default || require('./components/MainApp'));
    }, 'app');
  },
};



// WEBPACK FOOTER //
// ./routes/app/index.js